<template>
  <div class="box">
      <el-form autoComplete="on"
               :model="loginForm"
               :rules="loginRules"
               ref="loginForm"
               class="box-content"
               label-position="left">
        <h2 class="login-title">Create New Account</h2>
        <p style="font-size:18px;color:#343434;margin:57px 0 12px 0;">User ID:</p>
        <el-form-item prop="firstName">
          <el-input name="firstName" class="ipt"
                    type="text"
                    v-model="loginForm.firstName"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <p style="font-size:18px;color:#343434;margin:12px 0 12px 0;">Name:</p>
        <el-form-item prop="lastName">
          <el-input name="lastName" class="ipt"
                    type="text"
                    v-model="loginForm.lastName"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <p style="font-size:18px;color:#343434;margin:12px 0 12px 0;">My email address:</p>
        <el-form-item prop="emailAddress">
          <el-input name="emailAddress" class="ipt"
                    type="text"
                    v-model="loginForm.emailAddress"
                    autoComplete="off"
                    placeholder="">
          </el-input>
        </el-form-item>
        <p style="font-size:18px;color:#343434;margin:17px 0 8px 0;">Enter a Password:</p>
        <el-form-item prop="passWord">
          <el-input name="passWord" class="ipt"
                    :type="pwdType"
                    v-model="loginForm.passWord"
                    autoComplete="off"
                    placeholder="">
          </el-input>
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="pwdType === 'passWord' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <p style="font-size:18px;color:#343434;margin:17px 0 8px 0;">Confirm Password:</p>
        <el-form-item prop="comfirmPassword">
          <el-input name="comfirmPassword" class="ipt"
                    :type="pwdType"
                    v-model="loginForm.comfirmPassword"
                    autoComplete="off"
                    placeholder="">
          </el-input>
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="pwdType === 'passWord' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>
        <p style="font-size:18px;color:#343434;margin:12px 0 12px 0;">Secutity Code:</p>
        <el-form-item prop="code" style="display: flex;">
          <el-input name="code" class="ipt2"
                    type="text"
                    v-model="loginForm.code"
                    autoComplete="off"
                    placeholder="">
          </el-input>
          <Identify :identifyCode="identifyCode" />
          <span @click="refreshCode"><img src="../assets/code_icon.png"></span>
          <!-- <span @click="refreshCode">切换验证码</span> -->
        </el-form-item>
        <el-form-item prop="requiredAll">
            <el-checkbox v-model="loginForm.requiredAll">Privacy Policy</el-checkbox>
        </el-form-item>
        <el-form-item style="margin-bottom: 49px">
          <a class="loginBtn a1" :loading="loading" @click="handleRegister">
            SUBMIT
          </a>
        </el-form-item>
      </el-form>
  </div>
</template>

<script>
  import {isvalidUsername} from '@/utils/validate';
  import { userRegister } from '@/api/index' ;
  import Identify from './Identify'
  const defaultlogin = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    passWord: '',
    comfirmPassword: '',
    code: '',
    requiredAll: '',
  };
  export default {
    name: 'Register',
    components: { Identify },
    data() {
      const validateUsername = (rule, value, callback) => {
        if (!isvalidUsername(value)) {
          callback(new Error('Please enter the correct username'))
        } else {
          callback()
        }
      };
      const emailAddress = (rule, value, callback) => {
        let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (!reg.test(value)) {
          callback(new Error('Please enter the correct email address'))
        } else {
          callback()
        }
      };
      const validatePass = (rule, value, callback) => {
        let reg = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{6,}$/;
        if (value.length < 6 && !reg.test(value)) {
          callback(new Error('The password shall be at least 6 digits and contain numbers, Letter case'))
        } else {
          callback()
        }
      };
      return {
        loginForm: Object.assign({}, defaultlogin),
        loginRules: {
          firstName: [{required: true, trigger: 'blur', validator: validateUsername}],
          lastName: [{required: true, trigger: 'blur', validator: validateUsername}],
          emailAddress: [{required: true, trigger: 'blur', validator: emailAddress}],
          passWord: [{required: true, trigger: 'blur', validator: validatePass}]
        },
        loading: false,
        pwdType: 'passWord',
        identifyCode: '',
        // 验证码规则
        identifyCodes: '3456789ABCDEFGHGKMNPQRSTUVWXY',
      }
    },
    created() {
      //进入页面则刷新验证码图片
      this.refreshCode();
    },
    methods: {
      // 切换验证码
      refreshCode() {
        this.identifyCode = ''
        this.makeCode(6)
      },
      // 生成随机验证码
      makeCode(l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode += this.identifyCodes[Math.floor(Math.random() * (this.identifyCodes.length))]
        }
      },
      showPwd() {
        if (this.pwdType === 'passWord') {
          this.pwdType = ''
        } else {
          this.pwdType = 'passWord'
        }
      },
      handleRegister() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            if (this.identifyCode !== this.loginForm.code.toUpperCase()){
              this.$message.error("Invalid Security Code");
              return
            }
            if (this.loginForm.comfirmPassword != this.loginForm.passWord) {
              this.$message.error("Passwords must be entered consistently");
              return
            } else {
              this.loading = true;
              userRegister(this.loginForm).then((res) => {
                console.log(res, 'resgier');
                this.$router.push({name: "Login"});
                this.loading = false
              }).catch(() => {
                this.loading = false
              });
            }
            
          } else {
            return false
          }
        })
      },
    }
  }
</script>

<style scoped>
  .box{
    height:100%;
    width:100%;
    overflow: auto;
    min-height: 100vh;
    position: relative;
  }
  .box-content {
    /* width:550px;
    height:450px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 50px 0px rgba(232,62,66,0.12); */
    width:448px;
    position: absolute;
    left: 50%;
    top: 74px;
    transform: translateX(-50%);
    text-align:left;
    /* border-radius:22px; */
  }
  .login-title {
    font-size:30px;
    font-weight:bold;
    font-family:Arial;
    color:#000;
  }
  .ipt{
    width:423px;
    height:34px;
    /* border: 1px solid #e1e1e1 !important; */
    border: 0 !important;
    outline: none;
  }
  .ipt2 {
    width:202px;
    height:34px;
    border: 0 !important;
    outline: none;
  }
  ::v-deep .el-input__inner {
    border-radius: 0 !important;
    border: 1px solid #e1e1e1 !important;
    background-color: #fff !important;
  }
  ::v-deep input:-internal-autofill-selected {
    background-color: #fff !important;
  }
  .loginBtn{
    width:225px;
    height:48px;
    background: #00718c;
    border-radius:6px;
    color: #ffffff;
    font-size:20px;
    font-weight:bold;
    text-align:center;
    line-height:48px;
    display:block;
  }
  .boxCon{
    text-align: center;
  }
  .titlelogo{
    width:103px;
    height:41px;
    font-size:50px;
    /* font-family:Adobe Heiti Std R; */
    font-family: "Arial";
    font-weight:bold;
    color:rgba(247,59,66,1);
    line-height:169px;
  }
  .titlecon{
    width:358px;
    height:38px;
    font-size:40px;
    /* font-family:FZLTZHK--GBK1-0; */
    font-family: "Arial";
    font-weight:normal;
    color:rgba(255,255,255,1);
    line-height:89px;
    text-shadow:0px 0px 10px rgba(0, 0, 0, 0.14);
  }
  .el-form-item__error{
    left: 50%;
  }
  .el-input__inner{
    background-color: red;
  }
  ::v-deep .el-checkbox__label {
    font-size:18px !important;
    color:#343434 !important;
  }
  ::v-deep .el-form-item__content {
    display:flex;
  }
  /* ::v-deep .el-form-item__content {
    height: 36px !important;
    line-height: 36px !important;
  } */
  ::v-deep .el-input__inner {
    height: 36px !important;
    line-height: 36px !important;
  }
</style>